import React from "react";
import {useScrollContext} from "../ScrollContext";
import {useTranslation} from "react-i18next";

const Contact = () => {

    const {refs} = useScrollContext();
    const {t} = useTranslation();

    return (
        <div ref={refs.contact} className="row vc_custom_1466154433105 row-o-full-height row-o-columns-stretch row-o-equal-height">
            <div className="wpb_column vc_column_container column-4_12">
                <div className="vc_column-inner ">
                    <div className="wpb_wrapper"/>
                </div>
            </div>
            <div className="wpb_column vc_column_container column-4_12 vc_col-has-fill">
                <div className="vc_column-inner vc_custom_1466756857898">
                    <div className="wpb_wrapper">
                        <i id="sc_anchor_address" className="sc_anchor" title="Our Address"/>
                        <div className="vc_empty_space  height_medium" style={{height: '0px'}}/>
                        <div
                            className="sc_promo sc_promo_default sc_promo_size_normal sc_promo_no_paddings sc_promo_no_image">
                            <div className="sc_promo_text sc_float_center" style={{width: '100%'}}>
                                <div className="sc_promo_text_inner sc_align_center">
                                    <div className="sc_promo_icon"><span
                                        className="icon-address"/></div>
                                    <h2 className="sc_item_title sc_promo_title">{t('CONTACT.HOME_PAGE.TITLE')}</h2>
                                    <h5 className="sc_item_subtitle sc_promo_subtitle">{t('CONTACT.HOME_PAGE.SUBTITLE')}</h5>
                                    <div className="sc_promo_content sc_item_content">
                                        <div className="wpb_text_column wpb_content_element ">
                                            <div className="wpb_wrapper">
                                                <p><em><strong>{t('COMMON_WORDS.ADDRESS')}:</strong></em><br/> {t('CONTACT.ADDRESS')}
                                                </p>
                                                <p><em><strong>{t('COMMON_WORDS.PHONE')}:</strong></em><br/> {t('CONTACT.TEL3')}
                                                </p>
                                                <p><em><strong>{t('COMMON_WORDS.EMAIL')}:</strong></em><br/> {t('CONTACT.EMAIL')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sc_item_button sc_promo_button sc_button_wrap">
                                        <a href="https://www.facebook.com/winnicabugara" rel="noopener noreferrer" target="_blank"                                                                                                      className="sc_button sc_button_simple sc_button_size_normal sc_button_icon_top"><span
                                        className="sc_button_icon"><span className="icon-down-big"/></span><span
                                        className="sc_button_text"><span className="sc_button_title">{t('CONTACT.HOME_PAGE.BOTTOM_INFO')}</span></span>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                        <div className="vc_empty_space  height_medium" style={{height: '0px'}}/>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Contact;